<template>
  <div class="message-box">
    <div class="header">
      <span v-if="collapsable" class="float-right collapse-button" @click.stop="collapsed = !collapsed">
        <span :class="`${collapsed ? 'hidden' : ''}`">
          <i :class="`fad fax fa-arrow-circle-down`"></i>
        </span>
        <span :class="`${!collapsed ? 'hidden' : ''}`">
          <i :class="`fad fax fa-arrow-circle-up`"></i>
        </span>
      </span>
      <p>
        <i :style="{'color': iconColor}" :class="`${icon} icon`"></i>
        <span class="title">{{ title }}</span>
      </p>
    </div>

    <p class="content" v-if="!(collapsable && collapsed)">
      <slot/>
    </p>

    <span v-if="message !== ''" class="message">{{ message }}</span>

    <div v-if="autoIncassoButton">
      <b-button variant="danger" @click.stop="stopAutoIncasso">
        Stop automatische incasso
      </b-button>
    </div>

  </div>
</template>
<script>
import {registrationService} from "@/_services";

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fad fa-thumbs-up'
    },
    iconColor: {
      type: String,
      default: '#009e0f'
    },
    autoIncassoButton: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      collapsed: true,
    }
  },
  methods: {
    stopAutoIncasso() {
      registrationService.stopRecuringPayment()
        .then(() => {
          // reload the page
          window.location.reload()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.message-box {
  border: 1px solid #009e0f;
  border-radius: 3px;
  padding: 20px;
  margin-top: 10px;
}

.header {
  margin-bottom: 10px;

  .icon {
    font-size: 30px;
    vertical-align: middle;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    padding-left: 10px;
    vertical-align: middle;

  }
}

.content {
  margin-bottom: 0;
}

.message {
  color: #009e0f;
  font-weight: bold;
  margin-top: 1rem;
  display: block;
}

.collapse-button {
  cursor: pointer;
}
.collapse-button .fax{
  margin-left: 10px;
}
</style>